import React, { useState, useRef, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SimpleReactValidator from "simple-react-validator";

function Signup() {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [userName, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [isSubmit, setIsSubmit] = useState(false);
    const [passError, setPswError] = useState(false);
    const [, forceUpdate] = useState();
    const validator = useRef(new SimpleReactValidator({
        messages: {
            email: 'Please enter a valid username.'
        },
        autoForceUpdate: { forceUpdate }
    }));

    useEffect(() => {
        if (pass_reg.test(password)) {
            setPswError(false);
        }
    }, [password]);

    const handleSubmit = event => {
        setIsSubmit(true);
        if (!validator.current.allValid()) {
            console.log(validator.current)
            setIsSubmit(false);
            validator.current.showMessages();
            forceUpdate(1);
            return false;
        }
        if (!pass_reg.test(password)) {
            console.log("PASSWORD WRONG")
            return setPswError(true);
        }
        console.log("HERE")
        const request = new Request(`${interfaceConfig.API_URL}/User/SignUp`, {
            method: 'POST',
            headers: new Headers({ 'Content-Type': 'application/json' }),
            body: JSON.stringify({ userName, password, lastName, firstName })
        });
        fetch(request).then(res => {
            console.log("HERE",res)
            return res.status;
        }).then(status => {
            toast.success("Your account has been created successfully ", {
                position: toast.POSITION.TOP_LEFT
            });
            window.location.href = `${interfaceConfig.WEB_URL}`;
        }).catch(err => {
            setIsSubmit(false);
            toast.error("Invalid username and password", {
                position: toast.POSITION.TOP_LEFT
            });
            console.log('%c Err', 'font-size:20px;color:red', err);

        })
    };

    return (
        <section className="login_bg sign_up">
            <ToastContainer />
            <div className="container">
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                        <div className="col-lg-4 col-md-6 col-sm-6 col-xs-12">
                            <div className="login_block">
                                <div className="login_about">
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-sm-12">
                                        <form>
                                            <div className="form_login">
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <img src="../../../images/logo.png" style={{ width: '120px' }} className="center-block" alt="..." />
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12 text-center">
                                                        <h3>Sign Up</h3>

                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="firstName"
                                                                value={firstName}
                                                                onChange={(e) => setFirstName(e.target.value)}
                                                                placeholder="Firstname" />
                                                        </div>
                                                        {validator.current.message("Firstname", firstName, `required`)}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-envelope "></i>
                                                            </div>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="lastName"
                                                                value={lastName}
                                                                onChange={(e) => setLastName(e.target.value)}
                                                                placeholder="Lastname" />
                                                        </div>
                                                        {validator.current.message("Lastname", lastName, `required`)}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-user"></i>
                                                            </div>
                                                            <input type="text"
                                                                className="form-control"
                                                                name="userName"
                                                                value={userName}
                                                                onChange={(e) => setUsername(e.target.value)}
                                                                placeholder="Username" />
                                                        </div>
                                                        {validator.current.message("Username", userName, `required|email`)}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-sm-12">
                                                        <div className="input-group input-group-lg">
                                                            <div className="input-group-addon">
                                                                <i className="fa fa-lock"></i>
                                                            </div>
                                                            <input type="password"
                                                                className="form-control"
                                                                name="password"
                                                                value={password}
                                                                onChange={(e) => setPassword(e.target.value)}
                                                                placeholder="Password" />
                                                            <a href={void 0}><i className="fa fa-question-circle help_icon"></i></a>
                                                        </div>
                                                        {validator.current.message("Password", password, `required`)}
                                                        {passError && password ? <div className='srv-validation-message'>
                                                            Please enter a valid password
                                                        </div> : null}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="col-md-12">
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="col-xs-12 text-right">
                                                                    <button type="button" disabled={isSubmit} onClick={handleSubmit} className="btn btn-primary  btn-sm">{isSubmit ? "Please wait..." : "Signup"}</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-sm-3 col-xs-12"></div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Signup